module.exports = __webpack_public_path__ + "static/1-e9eeff575111b7c1131ef680b2f591b6.jpg";